import React from 'react';

import { SvgInfoCircle } from 'components/SvgIcon';

export const NoLicenseInfo = () => {
  return (
    <div className="m-user-edit-drawer-section__no-licenses-info">
      <div className="m-user-edit-drawer-section__no-licenses-info__icon">
        <SvgInfoCircle />
      </div>
      <div>
        <span className="m-user-edit-drawer-section__no-licenses-info__bold">
          Add licenses.{' '}
        </span>
        Add license for this user, so they can have access to this platform and
        get started.
      </div>
    </div>
  );
};
